require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/_core').Number.isNaN;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/fn/number/is-nan.js
// module id = 278
// module chunks = 0